import React from 'react';
import { VerificationPageProps } from '../../types/VerificationTypes';
import VerificationStatus from './VerificationStatus';
import CredentialCard from './CredentialCard';
import CredentialDetails from './CredentialDetails';
import VerificationMetadata from './VerificationMetadata';

const VerificationPage: React.FC<VerificationPageProps> = ({ data }) => {
  if (!data.verified || !data.credential) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
          <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-white text-2xl">✗</span>
          </div>
          <h1 className="text-2xl font-bold text-red-600 mb-4">Verification Failed</h1>
          <p className="text-gray-600">{data.error || 'Credential could not be verified'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-4 md:py-8">
        <VerificationStatus 
          verified={data.verified}
          verificationId={data.verification_info?.verification_id || 'N/A'}
          schemaName={data.credential.schema_name}
        />
        
        <CredentialCard credential={data.credential} />
        
        <CredentialDetails credential={data.credential} />
        
        {data.verification_info && (
          <VerificationMetadata 
            verificationInfo={data.verification_info}
            security={data.security}
          />
        )}
      </div>
    </div>
  );
};

export default VerificationPage; 